import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import allWithdrawal, {
  AllWithdrawalResponse,
} from "../services/getAllWithdraw";

function useAllWithdrawal(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<AllWithdrawalResponse>({
    queryKey: ["withdrawal", pagination, columnFilters, sorting],
    queryFn: () => allWithdrawal({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useAllWithdrawal;
